
import { caseStudies } from '../../../mocks/caseStudies';

export default function CaseStudiesSection() {
  // 임시 비활성화 - 향후 활성화 시 아래 return 문을 사용하세요
  return null; 
  
  /* 
  // 활성화 시 위의 return null;을 제거하고 아래 코드를 사용하세요
  const featuredCases = caseStudies.filter(study => study.featured).slice(0, 3);

  return (
    <section className="py-24 bg-gradient-to-b from-[#05070A] to-[#0f0f0f] relative overflow-hidden">
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#F6B766]/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-[#F6B766]/10 rounded-full mb-6">
            <i className="ri-file-list-3-line text-[#F6B766] mr-2"></i>
            <span className="text-[#F6B766] text-sm font-medium">Case Studies</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-light text-white mb-6">
            데이터로 증명된 <span className="text-[#F6B766]">성공 사례</span>
          </h2>
          <p className="text-xl text-white/60 max-w-3xl mx-auto leading-relaxed">
            실제 프로젝트에서 달성한 구체적인 성과를 확인해보세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {featuredCases.map((study) => (
            <div
              key={study.slug}
              onClick={() => window.REACT_APP_NAVIGATE(`/case-studies/${study.slug}`)}
              className="group cursor-pointer bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm border border-white/10 rounded-2xl overflow-hidden hover:border-[#F6B766]/30 transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={study.thumbnail}
                  alt={study.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 bg-[#F6B766] text-black text-xs font-semibold rounded-full">
                    {study.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-[#F6B766] font-medium text-sm">{study.client}</h3>
                  <span className="text-white/40 text-xs">{study.date}</span>
                </div>
                
                <h4 className="text-white font-semibold text-lg mb-3 group-hover:text-[#F6B766] transition-colors line-clamp-2">
                  {study.title}
                </h4>
                
                <p className="text-white/60 text-sm leading-relaxed mb-4 line-clamp-3">
                  {study.challenge}
                </p>

                {study.results && study.results.length > 0 && (
                  <div className="flex flex-wrap gap-2 mb-4">
                    {study.results.slice(0, 2).map((result, index) => (
                      <div key={index} className="px-3 py-1 bg-[#F6B766]/10 rounded-full">
                        <span className="text-[#F6B766] text-xs font-semibold">
                          {result.metric} {result.value}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
                
                <div className="flex items-center text-[#F6B766] font-medium text-sm">
                  <span className="mr-2">자세히 보기</span>
                  <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/case-studies')}
            className="inline-flex items-center px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#F6B766]/30 text-white rounded-xl transition-all group cursor-pointer whitespace-nowrap"
          >
            <span className="mr-2">모든 케이스 스터디 보기</span>
            <i className="ri-arrow-right-line group-hover:translate-x-2 transition-transform"></i>
          </button>
        </div>
      </div>
    </section>
  );
  */
}
